import service1 from "../../Images/ser-1.png"
import service2 from "../../Images/ser-2.png"
import service3 from "../../Images/ser-3.png"
import service4 from "../../Images/ser-4.png"
import service5 from "../../Images/ser-5.png"
import service6 from "../../Images/ser-6.png"
import service7 from "../../Images/ser-7.png";
import service8 from "../../Images/ser-8.png";
import service9 from "../../Images/ser-9.png";
import WhtArrow from "../../Images/white-arrow.png"

export const ServiceData =[
    {
        id : 1,
        name : "Anti-Lock  Brake Service",
        img : service1,
        arrow : WhtArrow
    },
    {
        id : 2,
        name : " Entire Full Engine Servicing",
        img : service2,
        arrow : WhtArrow
    },
    {
        id : 3,
        name : "Transmission Service & Repair",
        img : service3,
        arrow : WhtArrow
    },
    {
        id : 4,
        name : "Battery Replacement",
        img : service4,
        arrow : WhtArrow
    },
    {
        id : 5,
        name : "Car Wash and Cleaning Service",
        img : service5,
        arrow : WhtArrow
    },
    {
        id : 6,
        name : "Change Engine Oil and Filter",
        img : service6,
        arrow : WhtArrow
    },
    {
        id : 7,
        name : "Change Engine Oil and Filter",
        img : service7,
        arrow : WhtArrow
    },
    {
        id : 8,
        name : "A/C Services and Replacement",
        img : service8,
        arrow : WhtArrow
    },
    {
        id : 9,
        name : "Back Light Repair and Replacement",
        img : service9,
        arrow : WhtArrow
    },
    
]